import React, { FC } from 'react'

import { ProductTableItem } from '..'
import { RowForm } from 'modulesCommon/ProductTable/components'

import { IProductTableProps } from './ProductTable.props'

import './ProductTable.scss'

const ProductTable: FC<IProductTableProps> = ({
  products,
  editingRowIdx,
  handleRowClose,
  handleAddProduct,
  handleRowEdit,
  isEditable = true
}) => (
  <div className="product-table">
    <div className="product-table__header">
      <h4 className="product-table__col product-table__col--type">Type</h4>
      <h4 className="product-table__col product-table__col--name">Product Title</h4>
      <h4 className="product-table__col product-table__col--status">Status</h4>
      <h4 className="product-table__col product-table__col--date">Release Date</h4>
      {isEditable && <div className="product-table__col product-table__col--actions" />}
    </div>
    {products.map((product: any, idx: number) => idx === editingRowIdx ? (
      <RowForm
        key={product.id}
        product={product}
        idx={idx}
        handleRowClose={handleRowClose}
        handleAddProduct={handleAddProduct}
      />
    ) : (
      <ProductTableItem
        key={product.id}
        idx={idx}
        product={product}
        handleRowClose={handleRowClose}
        handleRowEdit={handleRowEdit}
        isEditable={isEditable}
      />
    ))}
  </div>
)

export default ProductTable
